import React, { Component } from "react";
import "./Recover.css";
import axios from "axios";
import spatiam_logo from "../assets/spatiam_logo_white.png";
import login_image from "../assets/manager_graphic17.png";
import ResetArea from "./ResetArea";
import Cookies from "js-cookie";
import { withRouter } from 'react-router-dom';

import { Link } from "react-router-dom";

class Reset extends Component {
  state = {
    valid_reset: "",
    csrftoken: "",
    validationErrors: [],
    modal: true,
    registered: false,
  };

  setRegistered = (isRegistered) => {
    this.setState({ registered: isRegistered });
  };

  getRegistered = () => {
    return this.state.registered;
  };

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  login = (event) => {
    let service = axios.create({
      baseURL: this.props.baseUrl+"/api",
      responseType: "json",
    });

    service
      .post("/auth/", this.state.credentials)
      .then((response) => {
        if (response.data.token) {
          this.props.userToken(response.data.token);
          this.props.userLogin(this.state.credentials.username);
        }
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  register = (event) => {
    let service = axios.create({
      baseURL: this.props.baseUrL+"/api",
      responseType: "json",
    });

    service
      .post("/api/users/", this.state.credentials)
      .then((response) => {
        this.login();
      })
      .catch((error) => {
      });
    return;
  };

  inputChanged = (event) => {
    const cred = this.state.credentials;
    cred[event.target.name] = event.target.value;
    this.setState({ credentials: cred });
  };

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;

    const error_tags = ["username", "password", "non_field_errors"];
    let errors = [];

    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      const error_tag = error_tags[i];
      const error_msg = validationErrors[error_tag];
      var msg = "";
      if (error_msg) {
        if (error_tag === "username") {
          msg = "Enter username";
        } else if (error_tag === "password") {
          msg = "Enter password";
        } else {
          msg = "The info doesn't match our records.\t Please try again.";
        }
        errors.push(<li key={error_tags[i]}>{msg}</li>);
      }
    }

    return errors;
  };

  reset_req = () => {
    const { uid, token } = this.props.match.params;

    if (this.state.valid_reset === "") {
      axios
        .get(`${this.props.baseUrl}/api/reset/${uid}/${token}/`, {
          withCredentials: true,
        })
        .then((response) => {
          const csrftoken = Cookies.get("csrftoken");
          if (csrftoken && !response.data.includes("Password reset unsuccessful")) {
            this.setState({csrftoken: csrftoken})
            this.setState({valid_reset: "successful"})
            return;
          } else {
            this.setState({valid_reset: "unsuccessful"})
            return;
          }
        })
        .catch((errors) => {
          this.setState({ validationErrors: errors.response.data });
          this.setState({valid_reset: "unsuccessful"})
        });
      return;
    }
  };

  render() {

    return (
      <div className="login">
        <div className="login_page">
          <a href="https://www.spatiam.com/">
            <img className="logo_image" src={spatiam_logo} alt="logo" />
          </a>
          <div className="login_area">
            <div className="input_area">
              {this.state.valid_reset==="successful" ? (
                <ResetArea baseUrl={this.props.baseUrl} baseDir={this.props.baseDir} params={this.props.match.params} csrftoken={this.state.csrftoken}/>
              ) : null}
              {this.state.valid_reset==="unsuccessful" ?
                <label>
                The password reset link was invalid, possibly because it has already been used.
                <br /><br />
                Please request a new password reset
                <Link to={this.props.baseDir+"/recover"}> here</Link>
                .
              </label>
              : null}
            </div>
            <div className="image_area">
              <img
                className="login_image"
                src={login_image}
                alt="Manage Your DTN Networks"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Reset);
